import type { FaireProductEntity } from "../../entity_types/product";

export const p_zq4skfzn5h: FaireProductEntity = {
  token: "p_zq4skfzn5h",
  type: "product",
  name: "Emerald Crystal Obelisk Point Tower – Abundance & Heart Healing",
  brandToken: "b_9c6sy2bfcu",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/1eaf2556c89a89805976aadd68c911a3b554925d3d999f4a04ec5889d0809004.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/11f4ead6eaf6aa7f3abfc212761f29d9da13a8c6c2f5dff8624e783787ca95b1.jpeg",
    "https://cdn.faire.com/fastly/0c687db148a1183fa204221efb5e2746ce941ebfb28de5bd9eb704943d57ee5a.jpeg",
    "https://cdn.faire.com/fastly/a9c1a563a00162988216311b095d91dc040429e743366e0ccd6c41cc7d0457e9.jpeg"
  ],
  priceDollars: 10,
  description: "\nDescription:\nInvite the vibrant energy of growth and abundance into your space with this Emerald tower, Known as a stone of prosperity and heart-centered healing, Emerald is celebrated for its deep green color and association with renewal, love, and vitality. This compact yet powerful tower is ideal for focusing energy, enhancing emotional balance, and bringing a sense of harmony into your environment.\n\nEmerald is believed to support the heart chakra, attract abundance, and inspire compassion and connection. This beautifully crafted tower is perfect for meditation, manifestation, or simply adding a touch of natural elegance to your decor.\n\n * Material: Natural Emerald \n * Features: Rich green color, polished tower form \n * Benefits: Promotes abundance, supports heart healing, enhances compassion \n * Use: Perfect for meditation, manifestation, or display ",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:01.793Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
